import {ReactNode} from 'react';
import * as css from './TicketCard.css';

interface FooterLink {
    label: string;
    href: string;
}

interface TicketCardProps {
    top?: ReactNode;
    children: ReactNode;
    footerLink?: FooterLink;
    hasFooter?: boolean;
    'data-cy'?: string;
}

function TicketCard({top, children, footerLink, hasFooter = true, 'data-cy': dataCy = 'ticket-card'}: TicketCardProps) {
    return (
        <css.cardScaler>
            <css.cardInner data-cy={dataCy}>
                {top && <css.top>{top}</css.top>}
                <css.middle>{children}</css.middle>
                {hasFooter && (
                    <css.footer className={footerLink ? 'with-link' : ''}>
                        {footerLink && (
                            <css.terms
                                href={footerLink.href}
                                target="_blank"
                                rel="noreferrer"
                                data-cy="ticket-card-terms">
                                {footerLink.label}
                            </css.terms>
                        )}
                        <css.logo />
                    </css.footer>
                )}
            </css.cardInner>
        </css.cardScaler>
    );
}

export default TicketCard;
